module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', [(_vm.site_view == 2 || (((Object.keys(_vm.menu_tab_inner_view).length == 0) || (_vm.menu_tab_inner_view.length == 0) || (_vm.menu_tab_inner_view[''])))) ? _c('div', [_c('div', {
    staticClass: "card-cd-categories",
    staticStyle: {
      "margin": "5px",
      "margin-left": "1em",
      "margin-top": "1.7em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide-x"
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('li', {
    staticClass: "c-menu-active",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.getSellpointProducts();
      }
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v("All")]), _vm._v(" "), _c('h6', {
    staticClass: "prd-name-2-lines"
  }, [_vm._v("All")])])])]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(data, index) {
    return (index < _vm.category_thumb_limit) ? _c('li', [_c('div', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setCategoryProducts(data)
        }
      }
    }, [_c('p', {
      staticClass: "ltr-1"
    }, [_vm._v(_vm._s(data.business_category_name))]), _vm._v(" "), _c('h6', {
      staticClass: "prd-name-2-lines"
    }, [_vm._v(_vm._s(data.business_category_name))])])])]) : _vm._e()
  }), _vm._v(" "), ((Object.keys(_vm.sellpoint_categories).length > _vm.category_thumb_limit)) ? _c('li', {
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'moreCategories'
      }
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v("More")]), _vm._v(" "), _c('h6', {
    staticClass: "prd-name-2-lines"
  }, [_vm._v("More")])])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), (_vm.set_in_view == 'moreCategories') ? _c('div', [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('h3', [_vm._v("Pick From")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('div', {
      staticClass: "card-row-x1 row"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setCategoryProducts(category)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(category.business_category_image && (category.business_category_image != '')) ? _c('img', {
      attrs: {
        "src": category.business_category_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 mp0"
    }, [_c('h5', [_vm._v(_vm._s(category.business_category_name))])])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return (((product.product_is_available == 1) && (product.product_is_addon == 0))) ? _c('div', {
      key: index,
      staticClass: "col-md-6 col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 mp0",
      staticStyle: {
        "border": "#f5f5f5 solid 1px",
        "background-color": "#fff",
        "padding-top": "0.5em"
      }
    }, [_c('div', {
      staticClass: "col-xs-4 mp0",
      staticStyle: {
        "padding-left": "0.5em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.prepSetPageView(1, product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "card-item-img"
    }, [((Object.keys(product.product_images).length > 0) && (product.product_images[0])) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8 mp0"
    }, [_c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "margin-top": "0.21em",
        "border-radius": "0",
        "padding": "1em",
        "padding-top": "0em",
        "padding-bottom": "0em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "prd-name-3-lines"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.prepSetPageView(1, product, index, product.product_items[0], 0)
        }
      }
    }, [_c('p', {
      staticClass: "prd-name-1-lines-x"
    }, [_c('b', [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "-0.51em"
      }
    }, [_c('span', {
      staticClass: "prd-name-2-lines-x",
      staticStyle: {
        "line-height": "0.8",
        "color": "#757575",
        "font-size": "13px"
      }
    }, [_vm._v("Enjoy " + _vm._s(product.product_name) + "  To enjoy this meal, select the number of quantities you want, place your order, \r\n                        and send evidence of payment, we will contact you with your order details.")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.5em"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('p', {
      staticStyle: {
        "line-height": "0.7"
      }
    }, [_c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (product.product_total_rating && (Number(product.product_total_rating) > 0)) ? _c('p', {
      staticClass: "rate",
      staticStyle: {
        "line-height": "0.7",
        "margin-top": "-0.2em"
      }
    }, _vm._l((Math.round(product.product_total_rating)), function(rate) {
      return _c('i', {
        staticClass: "fas fa-star",
        staticStyle: {
          "padding-right": "3px"
        }
      })
    })) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "display": "block"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "2px 2px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "34px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "2px 2px",
        "line-height": "0.3"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "24px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "2px 2px",
        "line-height": "0.4"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(1, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "2px 2px",
        "line-height": "0.4",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block"
      }
    }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "2px 2px",
        "line-height": "0.4",
        "border": "#f7df2b solid",
        "background-color": "#f7df2b"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setRemoveOrderProductItems(index);
        }
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "2px 2px",
        "line-height": "0.4",
        "border": "#f7df2b solid",
        "background-color": "#f7df2b"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
        }
      }
    }, [_vm._m(3, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])]) : _vm._e()
  }), _vm._v(" "), ((_vm.site_view == 1 && (_vm.set_order_list.length > 0)) && ((Object.keys(_vm.menu_tab_inner_view).length == 0) || (_vm.menu_tab_inner_view.length == 0) || (_vm.menu_tab_inner_view['']))) ? _c('div', {
    staticClass: "cd-order-bottom-0"
  }, [_c('div', {
    staticClass: "row66",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "52%"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [_vm._m(4), _vm._v(" "), (_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎"), _c('span', {
    staticStyle: {
      "margin-left": "-0.41em"
    }
  }, [_vm._v(_vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "48%"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#999",
      "font-size": "13px",
      "padding-left": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.set_order_list.length) + " item(s) selected")])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 btn-page-sizing-50",
    staticStyle: {
      "border-radius": "8px",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setProcessOrder()
      }
    }
  }, [_vm._v("Process Order")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()], 2) : _c('div', {
    staticStyle: {
      "position": "absolute",
      "z-index": "1000"
    }
  }, [(_vm.menu_tab_inner_view['viewProduct']) ? _c('div', [_c('div', {
    staticClass: "col-md-5 col-xs-12 mp0"
  }, [(_vm.site_view == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "-30vh",
      "background-color": "#ffffff"
    }
  }, [_c('a', {
    staticStyle: {
      "z-index": "5",
      "position": "absolute",
      "display": "block",
      "margin-top": "1em",
      "margin-left": "1em",
      "padding": "0.09em 0.91em",
      "background-color": "#ffffff",
      "border-radius": "50%"
    },
    on: {
      "click": function($event) {
        _vm.resetPageBackToView(1)
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-img-boxxx",
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [(_vm.product.product_images[0]) ? _c('img', {
    staticClass: "card-col-imgxx",
    attrs: {
      "id": "el-image",
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 2) ? _c('div', [_c('a', {
    staticStyle: {
      "z-index": "5",
      "display": "block",
      "margin-top": "0.1em",
      "margin-left": "0em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-img-boxxx"
  }, [(_vm.product.product_images[0]) ? _c('img', {
    staticClass: "card-col-imgxx",
    attrs: {
      "id": "el-image",
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "15em",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#757575"
    }
  }), _vm._v(" "), (_vm.product.product_description != '') ? _c('div', [_c('p', {
    staticClass: "prd-descr",
    attrs: {
      "id": "pLess"
    }
  }, [_c('span', {
    staticClass: "max-lines"
  }, [_vm._v(_vm._s(_vm.product.product_description) + ".")]), _vm._v(" "), ((_vm.product.product_description).length > 150) ? _c('span', [_vm._v(".."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("more")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pMore"
    }
  }, [_vm._v(_vm._s(_vm.product.product_description) + "...."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("less")])])]) : _vm._e(), _vm._v(" "), (((_vm.product.product_description == '') || ((_vm.product.product_description).length < 150))) ? _c('div', [_c('p', {
    staticClass: "prd-descr",
    staticStyle: {
      "line-height": "1.8",
      "color": "#757575"
    }
  }, [_vm._v("Enjoy " + _vm._s(_vm.product.product_name) + " from " + _vm._s(_vm.app_name) + ", we are here to serve you with your best local and \r\n                  international dishes. To enjoy this meal, select the number of quantities you want, place your order, \r\n                  and send evidence of payment, we will contct you with your order details.\r\n              ")])]) : _vm._e()]), _vm._v(" "), (_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 1)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {
      key: product_item_index
    }, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.2em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-1 mp0"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(7, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('p', [_c('span', {
      attrs: {
        "id": 'prdQty' + product_item_index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])
  })], 2) : _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', [_vm._v("Quantity")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "id": 'prdQty' + _vm.product_index
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "5px 6px 8px 6px",
      "border-radius": "50%",
      "line-height": "0.2",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "1 0.81em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "5px 6px 10px 6px",
      "border-radius": "50%",
      "line-height": "0.6",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "fixed",
      "bottom": "0",
      "z-index": "1",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#999",
      "font-size": "13px"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "-0.12em"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.product_item.product_item_price_f))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.checkProductOrderItems(_vm.product)) ? _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "border-radius": "8px",
      "padding": "15px 38px",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetPageBackToView(1)
      }
    }
  }, [_vm._v("Select")]) : _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "border-radius": "8px",
      "padding": "15px 38px",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.resetPageBackToView(1)
      }
    }
  }, [_vm._v("Select")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), (_vm.site_view == 1) ? _c('div', [((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    key: _vm.componentKey,
    staticClass: "pb_img",
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "xmg",
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.site_view == 2 || (((Object.keys(_vm.menu_tab_inner_view).length > 0)) && !(_vm.menu_tab_inner_view['']) && !(_vm.menu_tab_inner_view['viewProduct']))) ? _c('div', {
    staticClass: "card-desktop-order"
  }, [(_vm.site_view == 2 && (_vm.set_order_list.length == 0)) ? _c('div', {
    staticClass: "card-item-order-top"
  }, [_c('div', [_c('h1', [_vm._v("Place order"), _c('br'), _vm._v("@"), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_name))])])]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.business_display_image
    }
  })]) : _c('div', {
    staticClass: "card-item-order"
  }, [(_vm.site_view == 2) ? _c('div', [_c('h3', [_vm._v("Order Checkout")]), _vm._v(" "), ((_vm.set_order_list.length == 0)) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Items selected yet")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "20px"
    }
  }, [_vm._v("Please select items to order")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "padding-left": "0px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.set_order_list.length) + " item(s) selected")])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view['setOrderAddons']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#ffffff",
      "margin-top": "3em"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.4em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('processOrder')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {}, [_c('div', {}, _vm._l((_vm.set_order_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('div', {
      staticStyle: {
        "width": "90%",
        "height": "80px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 mp0"
    }, [_c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('p', {
      staticStyle: {
        "float": "right",
        "color": "#666565",
        "font-weight": "600",
        "font-size": "13px"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))]), _vm._v(" "), _c('p', [(_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "clear": "both",
        "float": "right",
        "padding": "8px 6px",
        "background-color": "#f7df2b",
        "border-color": "#f7df2b",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("x")])]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "5px 3px",
        "line-height": "1.6",
        "border": "#fcfbfb solid",
        "text-transform": "capitalize"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("+ add to order")])])])])])])
  }))])])])]), _vm._v(" "), ((_vm.set_order_list.length > 0)) ? _c('div', {
    staticClass: "cd-order-bottom"
  }, [_c('div', {}, [_c('div', [_c('div', {
    staticClass: "cd-order-bottom-top"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "float": "right"
    }
  }, [_c('b', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cd-order-bottom-bottom"
  }, [_c('button', {
    staticClass: "btn sp-button-02 cd-order-bottom-cta cd-order-bottom-cta-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOrderCheckout');
      }
    }
  }, [_vm._v("Checkout")])])])])]) : _vm._e()]) : (_vm.menu_tab_inner_view['setOrderCheckout']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    key: _vm.checkoutComponentKey,
    attrs: {
      "id": "setOrderCheckout"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.4em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('processOrder')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.6em 0.8em",
      "margin-top": "-1.0em"
    }
  }, [_c('div', {
    staticClass: "card-group-row",
    staticStyle: {
      "line-height": "0.8"
    },
    attrs: {
      "id": ""
    }
  }, [_c('h4', [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "card card-row-box-x",
    staticStyle: {
      "color": "#777777"
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 mp0"
  }, [(_vm.user.user_name && ((_vm.user.user_name != '') || (_vm.user.user_name != undefined))) ? _c('div', {
    attrs: {
      "id": "showUserDetails"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), ((_vm.user.user_phone != '') || (_vm.user.user_phone != undefined)) ? _c('p', [_vm._v(_vm._s(_vm.user.user_phone))]) : _vm._e(), _vm._v(" "), ((_vm.user.user_email != '') || (_vm.user.user_email != undefined)) ? _c('p', [_vm._v(_vm._s(_vm.user.user_email))]) : _vm._e()]) : _c('div', [_vm._m(12), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "1em 0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setPopViewBox('setContactDetails')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-size": "22px",
      "color": "#777777"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-group-row",
    attrs: {
      "id": ""
    }
  }, [_c('h4', [_vm._v("Delivery Details")]), _vm._v(" "), _c('div', {
    staticClass: "card card-row-box-x",
    staticStyle: {
      "color": "#777777"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 mp0",
    staticStyle: {
      "line-height": "1.0"
    }
  }, [_c('div', [(_vm.user.user_order_delivery_address && (_vm.user.user_order_delivery_address != '')) ? _c('p', {
    staticClass: "prd-name-1-line-clip",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.user.user_order_delivery_address))]) : _c('p', [_vm._v("No Delivery Address")]), _vm._v(" "), _c('p', [((_vm.user.user_order_delivery_city == '') || (_vm.user.user_order_delivery_city == undefined)) ? _c('span', [_vm._v("Not Set")]) : _c('span', [(_vm.user.user_order_delivery_city && ((_vm.user.user_order_delivery_city != '') && (_vm.user.user_order_delivery_city_id != 0))) ? _c('span', [_vm._v(_vm._s(_vm.user.user_order_delivery_city) + ",")]) : _vm._e(), _vm._v(" "), (_vm.user.user_order_delivery_state && (_vm.user.user_order_delivery_state != '')) ? _c('span', [_vm._v(" " + _vm._s(_vm.user.user_order_delivery_state))]) : _vm._e()])]), _vm._v(" "), (_vm.user.user_order_delivery_state_id > 0) ? _c('p', [(_vm.set_order_delivery_location && (_vm.set_order_delivery_location.business_delivery_option_price > 0)) ? _c('span', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.set_order_delivery_location.business_delivery_option_price)) + "\r\n                        ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "1em 0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setPopViewBox('setDeliveryDetails')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-size": "22px",
      "color": "#777777"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [_c('div', {
    staticClass: "card-group-row",
    attrs: {
      "id": ""
    }
  }, [_c('h4', [_vm._v("Payment Type")]), _vm._v(" "), _c('div', {
    staticClass: "card card-row-box-x",
    staticStyle: {
      "color": "#777777"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.3em 0",
      "margin-top": "-0.8em"
    }
  }, [(_vm.set_payment_mode != 1) ? _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "margin-top": "0.78em",
      "border-radius": "50%",
      "padding": "0px 2px",
      "height": "20px",
      "background-color": "#ffffff",
      "border": "4px solid #f7df2b",
      "opacity": "1"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_mode = 1;
        _vm.setPopViewBox('payDirect')
      }
    }
  }, [_vm._v(" ")]) : _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "margin-top": "0.78em",
      "border-radius": "2px",
      "padding": "2px 3px",
      "padding-bottom": "1px",
      "line-height": "0.4",
      "background-color": "#f7df2b",
      "border-color": "#f7df2b",
      "font-size": "16px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_mode = 0;
        _vm.displayOffComponent('payDirect')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "0.6em"
    }
  }, [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.3em 0",
      "margin-top": "-0.8em"
    }
  }, [(_vm.set_payment_mode != 4) ? _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "margin-top": "0.78em",
      "border-radius": "50%",
      "padding": "0px 2px",
      "height": "20px",
      "background-color": "#ffffff",
      "border": "4px solid #f7df2b",
      "opacity": "1"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_mode = 4;
        _vm.setPopViewBox('payBank')
      }
    }
  }, [_vm._v(" ")]) : _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "margin-top": "0.78em",
      "border-radius": "2px",
      "padding": "2px 3px",
      "line-height": "0.4",
      "background-color": "#f7df2b",
      "border-color": "#f7df2b",
      "font-size": "16px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_payment_mode = 0;
        _vm.displayOffComponent('payBank')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])]), _vm._v(" "), ((_vm.set_order_list.length > 0)) ? _c('div', {
    staticClass: "cd-order-bottom"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "0.35em",
      "padding-left": "0.2em",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "#eee solid 0px",
      "padding-top": "1em",
      "line-height": "0.8"
    }
  }, [(_vm.set_payment_mode > 0) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.41em"
    }
  }, [_c('div', [_vm._m(19), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "float": "right",
      "width": "20%"
    }
  }, [_c('b', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.set_order_delivery_location.business_delivery_option_price && (_vm.set_order_delivery_location.business_delivery_option_price > 0)) ? _c('div', [_vm._m(20), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "float": "right",
      "width": "20%"
    }
  }, [_c('b', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_delivery_location.business_delivery_option_price)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_payment_mode == 4) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(21), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "border-radius": "8px",
      "padding": "6px 12px",
      "background-color": "#fce852",
      "border-color": "#f7df2b",
      "font-size": "14px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_vm._m(22), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "float": "right",
      "width": "20%"
    }
  }, [_c('b', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {}, [(_vm.set_payment_mode == 0) ? _c('button', {
    staticClass: "btn sp-button-02 btn-page-sizing-100",
    staticStyle: {
      "width": "100%",
      "margin-top": "0.78em",
      "border-radius": "12px",
      "background-color": "#fce852",
      "border-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode);
      }
    }
  }, [_vm._v("Place Order")]) : _c('button', {
    staticClass: "btn sp-button-02 btn-page-sizing-100",
    staticStyle: {
      "width": "100%",
      "margin-top": "0.78em",
      "border-radius": "12px",
      "background-color": "#f7df2b",
      "border-color": "#f7df2b"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode);
      }
    }
  }, [_vm._v("\r\n                      Place Order "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]) : _vm._e()]) : (_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', [_c('div', {
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10em 2em",
      "padding": "0.6em 0.8em"
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "id": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em 0",
      "text-align": "center",
      "font-weight": "900",
      "font-size": "28px",
      "text-transform": "capitalize",
      "letter-spacing": "1px"
    }
  }, [_vm._v("Order Placed")]), _vm._v(" "), _c('div', {
    staticClass: "card card-row-box"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "margin-top": "0.78em",
      "border-radius": "12px",
      "padding": "10px 48px",
      "background-color": "#fce852",
      "border-color": "#f7df2b",
      "font-size": "18px"
    },
    attrs: {
      "href": '/placed/orders/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])])])])])])]) : (_vm.site_view == 2 || (_vm.menu_tab_inner_view['processOrder'])) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {}, [(_vm.site_view == 1) ? _c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.4em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _vm._m(24)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "padding-bottom": "25em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "card"
  }, [_c('div', {}, [_c('div', {}, _vm._l((_vm.set_order_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('div', {
      staticStyle: {
        "width": "90%",
        "height": "80px"
      }
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 mp0"
    }, [_c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.product_name) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'sub', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'add', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('p', {
      staticStyle: {
        "float": "right",
        "color": "#666565",
        "font-weight": "600",
        "font-size": "13px"
      }
    }, [_vm._v("₦‎" + _vm._s(item.product_item_price_f) + "\r\n                              ")]), _vm._v(" "), _c('p', [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "clear": "both",
        "float": "right",
        "padding": "8px 6px",
        "background-color": "#f7df2b",
        "border-color": "#f7df2b",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, item.product_index, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("x")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 mp0"
    }, [_c('div', {
      staticClass: "category-slide",
      staticStyle: {
        "margin-top": "0"
      }
    }, [((Object.keys(item.product_order_options).length > 0)) ? _c('ul', {
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProductOrderOptions(index, item, item.product_order_options)
        }
      }
    }, _vm._l((item.product_order_options), function(item, index) {
      return (index < 3) ? _c('li', {
        key: index,
        staticStyle: {
          "margin": "3px",
          "border": "#eee solid 1px",
          "padding": "5px 10px",
          "border-radius": "18px",
          "height": "40px"
        }
      }, [_c('div', {
        staticClass: "col-xs-12 mp0",
        staticStyle: {
          "margin-bottom": "1em"
        }
      }, [_c('div', {
        staticClass: "col-xs-1 mp0"
      }, [_c('div', {
        staticClass: "card-avatar-circle",
        staticStyle: {
          "width": "20px",
          "height": "20px"
        }
      }, [(item.product_info_set_image && (item.product_info_set_image != '')) ? _c('img', {
        staticClass: "card-img",
        attrs: {
          "src": item.product_info_set_image
        }
      }) : _c('img', {
        staticClass: "card-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-8",
        staticStyle: {
          "display": "block",
          "padding": "3px",
          "text-align": "center"
        }
      }, [_c('p', {
        staticClass: "prd-name",
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v(" " + _vm._s(item.product_info_set_name))])]), _vm._v(" "), _vm._m(25, true)])]) : _vm._e()
    }))]) : _vm._e()])])])])
  }))])]) : _vm._e(), _vm._v(" "), ((_vm.set_order_list.length > 0)) ? _c('div', {
    staticClass: "cd-order-bottom"
  }, [_c('div', {
    staticClass: "cd-order-bottom-top"
  }, [_vm._m(26), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "float": "right"
    }
  }, [_c('b', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cd-order-bottom-bottom",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.set_order_addons.length > 0) ? _c('button', {
    staticClass: "btn sp-button-02 cd-order-bottom-cta btn-page-sizing-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOrderAddons');
      }
    }
  }, [_vm._v("Proceed")]) : _c('button', {
    staticClass: "btn sp-button-02 cd-order-bottom-cta cd-order-bottom-cta-sm btn-page-sizing-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOrderCheckout');
      }
    }
  }, [_vm._v("Checkout")])])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container cd-order-options",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "infoBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop88"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cd-order-options-box"
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('infoBox')
      }
    }
  }, [_c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.set_view_box_2 == 'setProductOrderOptions') ? _c('div', {
    key: _vm.componentKey,
    staticClass: "rowvv"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "containerbb",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_list[_vm.set_order_options_item_index].product_order_options), function(option, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card col-xs-12 mp0"
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "60px",
        "height": "60px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0",
        "margin-bottom": "1em"
      }
    }, [(option.product_info_set_image && (option.product_info_set_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": option.product_info_set_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name-1-lines",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(option.product_info_set_name) + " "), _c('br'), _vm._v(" "), (option.product_info_set_cost > 0) ? _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(option.product_info_set_cost))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', [(option.set_status == 1) ? _c('a', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "margin-top": "0em"
      },
      on: {
        "click": function($event) {
          _vm.setItemProductOrderOptions(option, index, _vm.product_item, _vm.set_order_options_item_index)
        }
      }
    }, [_vm._v("Dont't add")]) : (option.set_status == 0) ? _c('a', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "margin-top": "0em"
      },
      on: {
        "click": function($event) {
          _vm.setItemProductOrderOptions(option, index, _vm.product_item, _vm.set_order_options_item_index)
        }
      }
    }, [_vm._v("Add")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), (option.set_status == 0) ? _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin-top": "-40px",
        "border-top": "#000000 solid 2px"
      }
    }) : _vm._e()])
  }))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "containerx pop-box",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "popViewBox"
    }
  }, [_c('div', {
    staticClass: "pop-box-wrap"
  }, [_c('div', {
    staticClass: "pop-box-wrap-inner"
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid 0px",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('popViewBox')
      }
    }
  }, [_vm._m(28), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bolder",
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0.5em 1.0em"
    }
  }, [(_vm.set_pop_view == 'setContactDetails') ? _c('div', [_c('div', {
    staticStyle: {
      "display": "block"
    }
  }, [((_vm.user.user_name != '') || (_vm.user.user_name != undefined)) ? _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "showUserDetails"
    }
  }, [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('showUserDetails', 'setUserDetails')
      }
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setUserDetails"
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPopViewBox('')
      }
    }
  }, [_vm._v("Ok, Save")])])])])]) : (_vm.set_pop_view == 'setDeliveryDetails') ? _c('div', [_c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "col-xs-12"
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_c('hr'), _vm._v(" "), _vm._m(29), _vm._v(" "), (_vm.business_delivery_options_nodes && (Object.keys(_vm.business_delivery_options_nodes).length > 1)) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_state),
      expression: "set_state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.set_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.set_locations = _vm.set_state.state_locations;
        _vm.set_order_delivery_location = _vm.set_locations[0]
      }]
    }
  }, _vm._l((_vm.business_delivery_options_nodes), function(state, index) {
    return _c('option', {
      domProps: {
        "value": state
      }
    }, [_vm._v(_vm._s(state.state_name))])
  }))]), _vm._v(" "), (Object.keys(_vm.set_locations).length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_order_delivery_location),
      expression: "set_order_delivery_location"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.set_order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.user.user_order_delivery_address = '';
        _vm.setOrderDeliveryLocation(_vm.set_order_delivery_location);
        _vm.set_inner_view = 'setLocations'
      }]
    }
  }, _vm._l((_vm.set_locations), function(location, lodex) {
    return _c('option', {
      domProps: {
        "value": location
      }
    }, [_vm._v(_vm._s(location.business_delivery_option))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setLocations') ? _c('div', {
    key: _vm.componentKey,
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('p', [_c('b', [_vm._v("Delivery Fee: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#777777"
    }
  }, [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.set_order_delivery_location.business_delivery_option_price)))])])]), _vm._v(" "), (_vm.set_order_delivery_location && (Object.keys(_vm.set_order_delivery_location).length > 0)) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_order_delivery_address),
      expression: "user.user_order_delivery_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.user.user_order_delivery_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_order_delivery_address = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.set_order_delivery_location.user_location_addresses && (_vm.set_order_delivery_location.user_location_addresses).length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v("Your addresses in this location")]), _vm._v(" "), _vm._l((_vm.set_order_delivery_location.user_location_addresses), function(address, adex) {
    return _c('div', {
      key: adex
    }, [(address.address_id && (address.address_id > 0)) ? _c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt btn-b",
      on: {
        "click": function($event) {
          _vm.user.user_order_delivery_address = address.address_address;
          _vm.componentKey++;
        }
      }
    }, [(_vm.user.user_order_delivery_address == address.address_address) ? _c('span', [_c('i', {
      staticClass: "fas fa-check",
      staticStyle: {
        "color": "#000",
        "border": "#666 solid 0px"
      }
    })]) : _c('span', [_c('i', {
      staticClass: "fas fa-square",
      staticStyle: {
        "color": "#eee",
        "border": "#666 solid 1px"
      }
    })])]), _vm._v("\r\n                                    " + _vm._s(address.address_address) + "\r\n                                  ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.set_in_view = 'ed-' + adex
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.set_in_view == 'ed-' + adex) ? _c('div', [_vm._m(30, true)]) : _vm._e()]) : (address.user_delivery_id && (address.user_delivery_id > 0)) ? _c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt btn-b",
      on: {
        "click": function($event) {
          _vm.user.user_order_delivery_address = address.user_delivery_address;
          _vm.componentKey++;
        }
      }
    }, [(_vm.user.user_order_delivery_address == address.user_delivery_address) ? _c('span', [_c('i', {
      staticClass: "fas fa-check",
      staticStyle: {
        "color": "#000",
        "border": "#666 solid 0px"
      }
    })]) : _c('span', [_c('i', {
      staticClass: "fas fa-square",
      staticStyle: {
        "color": "#eee",
        "border": "#666 solid 1px"
      }
    })])]), _vm._v("\r\n                                    " + _vm._s(address.user_delivery_address) + "\r\n                                  ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "id": 'manage-' + adex
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('ed-' + adex)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "id": 'ed-' + adex
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "padding": "2px 3.05em"
      },
      attrs: {
        "id": "setEditUserDeliveryAddress"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      staticStyle: {
        "border-radius": "45px",
        "padding": "5px 15px",
        "border-color": "#000",
        "background-color": "#000",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('editUserDeliveryAddress', 'setEditUserDeliveryAddress')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      staticStyle: {
        "color": "#fff"
      }
    }), _vm._v(" edit")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      staticStyle: {
        "border-radius": "45px",
        "padding": "5px 15px",
        "border-color": "#000",
        "background-color": "#000",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('deleteUserDeliveryAddress', 'setEditUserDeliveryAddress')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      staticStyle: {
        "color": "#fff"
      }
    }), _vm._v(" delete")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "editUserDeliveryAddress"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {}, [_vm._v("Edit Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (address.user_delivery_address),
        expression: "address.user_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Address"
      },
      domProps: {
        "value": (address.user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          address.user_delivery_address = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      staticStyle: {
        "margin-top": "5px",
        "border-radius": "8px",
        "padding": "8px 15px",
        "background-color": "#000",
        "color": "#fff",
        "border-color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.setUserDetails(3, address, 3)
        }
      }
    }, [_vm._v("Save\r\n                                              ")]), _vm._v(" \r\n                                              "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      staticStyle: {
        "margin-top": "5px",
        "border-radius": "8px",
        "padding": "8px 15px",
        "background-color": "#000",
        "color": "#fff",
        "border-color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('editUserDeliveryAddress', 'setEditUserDeliveryAddress')
        }
      }
    }, [_vm._v("Cancel\r\n                                              ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "deleteUserDeliveryAddress"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(" Delete this Location ?")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      staticStyle: {
        "margin-top": "5px",
        "border-radius": "8px",
        "padding": "8px 15px",
        "background-color": "#000",
        "color": "#fff",
        "border-color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.setUserDetails(4, address, 3);
          _vm.toggleDoubleComponent('deleteUserDeliveryAddress', 'setEditUserDeliveryAddress')
        }
      }
    }, [_vm._v("Yes\r\n                                            ")]), _vm._v("   \r\n                                            "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      staticStyle: {
        "margin-top": "5px",
        "border-radius": "8px",
        "padding": "8px 15px",
        "background-color": "#000",
        "color": "#fff",
        "border-color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('deleteUserDeliveryAddress', 'setEditUserDeliveryAddress')
        }
      }
    }, [_vm._v("Cancel\r\n                                            ")])])])])])])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.business_delivery_options_nodes), function(state, index) {
    return _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('stateLocations-' + index)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('p', [_vm._v(_vm._s(state.state_name))])]), _vm._v(" "), _vm._m(31, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "margin-bottom": "1em"
      },
      attrs: {
        "id": 'stateLocations-' + index
      }
    }, [_c('hr'), _vm._v(" "), _vm._l((state.state_locations), function(location, lodex) {
      return _c('div', [_c('p', [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.set_order_delivery_location),
          expression: "set_order_delivery_location"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": location,
          "checked": _vm._q(_vm.set_order_delivery_location, location)
        },
        on: {
          "click": function($event) {
            _vm.set_in_view = 'DL-' + index + '-' + lodex;
            _vm.user.user_order_delivery_address = '';
            _vm.setOrderDeliveryLocation(location)
          },
          "__c": function($event) {
            _vm.set_order_delivery_location = location
          }
        }
      })]), _vm._v("\r\n                                  " + _vm._s(location.business_delivery_option) + " - "), _c('span', {
        staticStyle: {
          "margin-right": "-0.5em"
        }
      }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(location.business_delivery_option_price)) + "\r\n                              ")]), _vm._v(" "), (_vm.set_in_view == 'DL-' + index + '-' + lodex) ? _c('div', {
        key: _vm.componentKey
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('label', {}, [_vm._v("Address")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.user.user_order_delivery_address),
          expression: "user.user_order_delivery_address"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Address"
        },
        domProps: {
          "value": (_vm.user.user_order_delivery_address)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.user.user_order_delivery_address = $event.target.value
          }
        }
      })]), _vm._v(" "), (location.user_location_addresses && (location.user_location_addresses).length > 0) ? _c('div', {
        staticClass: "col-xs-12"
      }, [_c('p', {
        staticStyle: {
          "margin-top": "5px",
          "color": "#ff0000",
          "font-size": "13px"
        }
      }, [_vm._v("Your addresses in this location")]), _vm._v(" "), _vm._l((location.user_location_addresses), function(address, adex) {
        return _c('div', {
          key: adex
        }, [(address.address_id && (address.address_id > 0)) ? _c('p', [_c('button', {
          staticClass: "btn sp-button-02-lt btn-b",
          on: {
            "click": function($event) {
              _vm.user.user_order_delivery_address = address.address_address;
              _vm.componentKey++;
            }
          }
        }, [_vm._m(32, true)]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v(_vm._s(address.address_address))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("edit delete")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "clear": "both"
          }
        })]) : (address.user_delivery_id && (address.user_delivery_id > 0)) ? _c('p', [_c('button', {
          staticClass: "btn sp-button-02-lt btn-b",
          on: {
            "click": function($event) {
              _vm.user.user_order_delivery_address = address.user_delivery_address;
              _vm.componentKey++;
            }
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(address.user_delivery_address))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("edit delete")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "clear": "both"
          }
        })]) : _vm._e()])
      })], 2) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('hr')], 2)])
  })], 2) : _c('div', [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location,
        "checked": _vm._q(_vm.set_order_delivery_location, location)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location
        }
      }
    })]), _vm._v("\r\n                              " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - ₦‎" + _vm._s(location.business_delivery_option_price) + "\r\n                          ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _c('div', [_c('hr'), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.sortDeliveryPartnersLocationDetails()
      }
    }
  }, [_vm._v("Set location")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._v("\r\n                        There are also delivery businesses that can bring your ordr and deliver it for you.\r\n                        "), ((Object.keys(_vm.delivery_partners_locations_details).length > 0)) ? _c('div', _vm._l((_vm.delivery_partners_locations_details), function(location, lodex) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(location.business_delivery_partner_name))]), _vm._v(" "), _c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option)
      },
      on: {
        "click": function($event) {
          _vm.set_in_view = 'DLX--' + lodex;
          _vm.user.user_order_delivery_address = '';
          _vm.setOrderDeliveryLocation(location.business_delivery_option)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option
        }
      }
    })]), _vm._v("\r\n                                " + _vm._s(location.business_delivery_option.business_delivery_option) + " - "), _c('span', {
      staticStyle: {
        "margin-right": "-0.5em"
      }
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(location.business_delivery_option.business_delivery_option_price)) + "\r\n                            ")]), _vm._v(" "), (_vm.set_in_view == 'DLX--' + lodex) ? _c('div', {
      key: _vm.componentKey
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {}, [_vm._v("Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.user_order_delivery_address),
        expression: "user.user_order_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Address"
      },
      domProps: {
        "value": (_vm.user.user_order_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.user.user_order_delivery_address = $event.target.value
        }
      }
    })]), _vm._v(" "), (location.user_location_addresses && (location.user_location_addresses).length > 0) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('p', {
      staticStyle: {
        "margin-top": "5px",
        "color": "#ff0000",
        "font-size": "13px"
      }
    }, [_vm._v("Your addresses in this location")]), _vm._v(" "), _vm._l((location.user_location_addresses), function(address, adex) {
      return _c('div', {
        key: adex
      }, [(address.address_id && (address.address_id > 0)) ? _c('p', [_c('button', {
        staticClass: "btn sp-button-02-lt btn-b",
        on: {
          "click": function($event) {
            _vm.user.user_order_delivery_address = address.address_address;
            _vm.componentKey++;
          }
        }
      }, [_vm._m(34, true)]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(address.address_address))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("edit delete")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "clear": "both"
        }
      })]) : (address.user_delivery_id && (address.user_delivery_id > 0)) ? _c('p', [_c('button', {
        staticClass: "btn sp-button-02-lt btn-b",
        on: {
          "click": function($event) {
            _vm.user.user_order_delivery_address = address.user_delivery_address;
            _vm.componentKey++;
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(address.user_delivery_address))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("edit delete")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "clear": "both"
        }
      })]) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()])
  })) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right",
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setUserDeliveryLocation();
        _vm.toggleSingleComponent('popViewBox')
      }
    }
  }, [_vm._v("Ok, Save")])])]) : (_vm.set_pop_view == 'payDirect') ? _c('div', [_c('div', [((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_vm._m(35), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(36)])]) : (_vm.set_pop_view == 'payBank') ? _c('div', [_c('div', [_c('h4', {
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("Amount to pay: "), _c('b', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))])]), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "setUploadPhoto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "border-top": "#eee solid",
      "padding-top": "5px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#666",
      "font-size": "13px"
    }
  }, [_vm._v("Make Payment and Upload Proof of Payment ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "border-radius": "8px",
      "padding": "10px 28px",
      "background-color": "#fce852",
      "border-color": "#f7df2b",
      "font-size": "18px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Reset")])]) : _vm._e()])])])]), _vm._v(" "), ((Object.keys(_vm.file_info).length > 0)) ? _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right",
      "margin-top": "2em",
      "position": "fixed",
      "bottom": "0px",
      "right": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('popViewBox');
        _vm.setMakeOrder(_vm.set_payment_mode);
      }
    }
  }, [_vm._v("Done, Place Order")])]) : _vm._e()]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#999"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "2em",
      "color": "#000000"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "2em",
      "color": "#000000"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.6em 0.8em"
    }
  }, [_c('h3', [_vm._v("Add to Order")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#9c9a9a",
      "font-size": "18px"
    }
  }, [_vm._v("items you should buy with this order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#d6d6d6",
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total11")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.1em 0.8em",
      "margin-top": "-1em"
    }
  }, [_c('h3', [_vm._v("Checkout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 mp0"
  }, [_c('div', {
    staticClass: "card card-icon"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Name & Phone / Email: ")]), _vm._v("Not Set")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_c('i', [_vm._v("Provide Name, Phone Number or Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 mp0"
  }, [_c('div', {
    staticClass: "card card-icon"
  }, [_c('i', {
    staticClass: "fas fa-shipping-fast"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 mp0"
  }, [_c('div', {
    staticClass: "card card-icon"
  }, [_c('i', {
    staticClass: "fas fa-credit-card"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-9 mp0"
  }, [_c('div', [_c('p', [_c('b', [_vm._v("Pay with ATM / Debit Cards and Online Bank Transfer")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-1.02em"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "height": "38px"
    },
    attrs: {
      "src": "/static/assets/images/payonline.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 mp0"
  }, [_c('div', {
    staticClass: "card card-icon"
  }, [_c('i', {
    staticClass: "fas fa-bank"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-9 mp0"
  }, [_c('div', [_c('p', [_c('b', [_vm._v("Pay to Bank")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777777",
      "margin-top": "-0.4em"
    }
  }, [_vm._v("Pay directly to bank account")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#777777",
      "float": "left",
      "width": "80%",
      "font-size": "16px"
    }
  }, [_c('b', [_vm._v("Order Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#777777",
      "float": "left",
      "width": "80%",
      "font-size": "16px"
    }
  }, [_c('b', [_vm._v("Delivery Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "float": "left",
      "color": "#666",
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Bank Payment")]), _vm._v(" "), _c('br'), _vm._v("Upload Receipt after payment ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#777777",
      "float": "left",
      "width": "80",
      "font-size": "16px"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 25%"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "6.5em"
    },
    attrs: {
      "src": "/static/assets/images/success-good-mark.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.6em 0.8em"
    }
  }, [_c('h3', [_vm._v("Checkout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 mp0",
    staticStyle: {
      "margin-top": "-0.3em"
    }
  }, [_c('span', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "14px",
      "color": "#ff0000 !important"
    }
  }, [_vm._v("x")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#d6d6d6",
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h4', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Order Options")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("Remove items you don't want included in this item order")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("Select where you want this order delivered to")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" edit")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-bin"
  }), _vm._v(" delete")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "2px 5px 1px 5px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("Select where you want this order delivered to, \r\n                          please note that the seller is not mandated to deliver to you. You are simply adding the information for possible considerations\r\n                        Charges may apply.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {}, [_vm._v("please provide your "), _c('b', [_vm._v("email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch"
  }), _vm._v(" You would be directed to a secured payment section")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edfd187a"}!./src/pages/Components/V_ItemsOrder/template.html
// module id = 631
// module chunks = 0